import makeStyles from "@mui/styles/makeStyles";
export default makeStyles(function (_a) {
    var _b, _c, _d, _e, _f;
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography, breakpoints = _a.breakpoints;
    var background = palette.background, error = palette.error, secondary = palette.secondary;
    var fontFamily = typography.fontFamily, bold = typography.fontWeightBold, medium = typography.fontWeightMedium, pxToRem = typography.pxToRem;
    return {
        modal: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
        },
        outerDiv: {
            outline: "none",
        },
        container: (_b = {
                width: spacing(40)
            },
            _b[breakpoints.only("sm")] = {
                width: spacing(50),
            },
            _b[breakpoints.up("md")] = {
                maxWidth: spacing(120),
                minWidth: spacing(80),
            },
            _b),
        buttonItem: (_c = {
                display: "flex",
                justifyContent: "flex-end"
            },
            _c[breakpoints.down("sm")] = {
                paddingLeft: spacing(30),
            },
            _c),
        buttonLabel: (_d = {
                color: secondary.light,
                fontFamily: fontFamily,
                fontWeight: bold,
                fontSize: pxToRem(22)
            },
            _d[breakpoints.down("md")] = {
                fontSize: pxToRem(16),
            },
            _d),
        paper: {
            backgroundColor: background.paper,
            padding: spacing(10, 8, 10, 8),
        },
        icon: (_e = {
                color: error.dark
            },
            _e[breakpoints.down("md")] = {
                fontSize: pxToRem(80),
            },
            _e.fontSize = pxToRem(125),
            _e.fontWeight = medium,
            _e.paddingBottom = spacing(4),
            _e),
        innerText: (_f = {
                textAlign: "center",
                fontSize: pxToRem(32)
            },
            _f[breakpoints.down("md")] = {
                fontSize: pxToRem(15),
            },
            _f),
        alert: {
            color: error.dark,
            fontWeight: bold,
        },
    };
});
//# sourceMappingURL=useStyles.js.map